import {RepositoryFactory} from '@/repositories/RepositoryFactory';

const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

export default {
    methods: {
        getImageFullPath(url) {
            return `${process.env.VUE_APP_S3_PREFIX}${url}`;
        },
        async uploadImage(base64) {
            const {data} = await PrintingDiyRepository.uploadImage(base64);
            return data.publicPath;
        },
    },
};